import {
    lesson20Assignment1,
    lesson20Assignment2,
    lesson20Assignment3,
    lesson20Assignment4
} from './assignments'
import { BLACK_PIECE_SEARCH_KEY, WHITE_INITIAL_MOVE, WHITE_PIECE_SEARCH_KEY, BLACK_INITIAL_MOVE } from '../../utils/constants';
import { createChessboard } from '../../utils';

let lessonConfig = [
    {
        id: 0,
        previous: null,
        next: 2,
        video: {
            src: 'img/videos/lesson_20/1.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 1
        }
    },
    {
        id: 1,
        previous: 0,
        next: 2,
        audio: { src: 'img/audio/lesson_20/1.mp3', start: true, controls: false },
        chessboard: {
            board: lesson20Assignment1({
                showIndicators: { allSides: true },
                position: 'rnbqkbnr/1p2pp1p/p2p2p1/2p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R',
                finalPosition: 'rnbqkbnr/1p2pp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                resultFen: [
                    'r1bqkbnr/1p1npp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                    'r1bqkbnr/1p2pp1p/p1np2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                    'rn1qkbnr/1p1bpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                    'rnb1kbnr/1p1qpp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R',
                    'rnbqkbnr/1p2pp1p/3p2p1/1pp5/3PP3/2N2N2/PPP2PPP/R1BQK2R'
                ],
                arrowFrom: 'square-b5',
                arrowTo: 'square-d8',
                offset: [0,0,10,10],
                from: 'f1',
                to: 'b5',
                magnusText: 'There are four possible blocks and one capture.<br>Find them all!',
                assignmentClass: 'custom-sparepiece',
                next: 2
            }),
            canvas: true,
            positionFen: 'rnbqkbnr/1p2pp1p/p2p2p1/1Bp5/3PP3/2N2N2/PPP2PPP/R1BQK2R b - - 0 1'
        }
    },
    {
        id: 2,
        previous: 0,
        next: 4,
        video: {
            src: 'img/videos/lesson_20/2.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 3
        }
    },
    {
        id: 3,
        previous: 2,
        next: 4,
        audio: { src: 'img/audio/lesson_20/2.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS:</b><br>This is a checkmate in three moves for White.<br>You play White.'
        },
        chessboard: {
            board: lesson20Assignment2({
                showIndicators: { allSides: true },
                position: 'r1bq1r1k/1p3p2/p2p1p2/4p3/4PP2/P2Q4/1PP4P/1K1R2R1',
                resultFen: 'r2q2rk/1p3p2/p2p1p2/4pP2/8/P6Q/1PP4P/1K1R2R1',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                moves: {
                    studentMove: {
                        from: ['f4', 'e4', 'd3'],
                        to: ['f5', 'f5', 'h3']
                    },
                    computerMove: {
                        from: ['c8', 'f8'],
                        to: ['f5', 'g8']
                    }
                },
                magnusText: 'That move won\'t get you checkmate in 3',
                magnusInitialText: 'Here\'s a hint!<br>Move the pawn to f5',
                next: 4
            }),
            positionFen: 'r1bq1r1k/1p3p2/p2p1p2/4p3/4PP2/P2Q4/1PP4P/1K1R2R1 w - - 0 1'
        },
    },
    {
        id: 4,
        previous: 2,
        next: 6,
        video: {
            src: 'img/videos/lesson_20/3.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 5
        }
    },
    {
        id: 5,
        previous: 4,
        next: 6,
        audio: { src: 'img/audio/lesson_20/3.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>This is a checkmate in two moves for White.<br>You play White.'
        },
        chessboard: {
            board: lesson20Assignment2({
                showIndicators: { allSides: true },
                position: '7k/8/pR6/1p3K2/8/6P1/rP6/8',
                resultFen: '7k/8/pR4K1/1p6/8/6P1/rP6/8',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: BLACK_PIECE_SEARCH_KEY,
                initialMoveOf: WHITE_INITIAL_MOVE,
                moves: {
                    studentMove: {
                        from: ['f5', 'b6'],
                        to: ['g6', 'b8']
                    },
                    computerMove: {
                        from: ['h8'],
                        to: ['g8']
                    }
                },
                magnusText: 'That\'s not going to get you to checkmate.',
                magnusInitialText: 'Here\'s a hint!<br>Move the King to g6',
                next: 6
            }),
            positionFen: '7k/8/pR6/1p3K2/8/6P1/rP6/8 w - - 0 1'
        },
    },
    {
        id: 6,
        previous: 4,
        next: 8,
        video: {
            src: 'img/videos/lesson_20/4.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 7
        }
    },
    {
        id: 7,
        previous: 6,
        next: 8,
        audio: { src: 'img/audio/lesson_20/4.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>This is a checkmate in two moves for Black.<br>You move for Black.'
        },
        chessboard: {
            board: lesson20Assignment2({
                showIndicators: { allSides: true },
                position: 'k7/8/pp6/P2Pn3/8/6P1/RPP1r3/7K',
                resultFen: 'k7/8/pp6/P2P4/8/5nP1/1PP4r/R6K',
                assignmentClass: 'custom-sparepiece',
                restrictMoveOf: WHITE_PIECE_SEARCH_KEY,
                initialMoveOf: BLACK_INITIAL_MOVE,
                moves: {
                    studentMove: {
                        from: ['e5', 'e2'],
                        to: ['f3', 'h2']
                    },
                    computerMove: {
                        from: ['a2'],
                        to: ['a1']
                    }
                },
                magnusText: 'That\'s not going to get you to checkmate in two.',
                magnusInitialText: 'Here\'s a hint!<br>Move the Knight to f3',
                next: 8
            }),
            positionFen: 'k7/8/pp6/P2Pn3/8/6P1/RPP1r3/7K b - - 0 1'
        },
    },
    {
        id: 8,
        previous: 6,
        next: 11,
        video: {
            src: 'img/videos/lesson_20/5.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 9
        }
    },
    {
        id: 9,
        previous: 8,
        next: 11,
        audio: { src: 'img/audio/lesson_20/5.mp3', start: true, controls: false },
        directions: {
            data: '<b>DIRECTIONS</b><br>Place the Black Queen on the board to create checkmate.'
        },
        chessboard: {
            board: lesson20Assignment3({
                showIndicators: { allSides: true },
                position: 'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/1K1NR2R',
                piecesArray: ['bQ'],
                validatePieces: { 'bQ': ['a1'] },
                pieceLimit: { bQ: 1 },
                fen: 'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/qK1NR2R',
                pieceTheme: 'simple_black_white',
                assignmentClass: 'custom-sparepiece',
                next: 11
            })
        }
    },
    {
        id: 10,
        previous: 9,
        next: 11,
        chessboard: {
            board: lesson20Assignment4({
                showIndicators: { allSides: true },
                position: 'r4rk1/p3ppbp/2np2p1/2p5/4P1PP/1P2BP2/P1PQ4/qK1NR2R',
                assignmentClass: 'custom-sparepiece',
                from: ["square-g7"],
                to: ["square-a1"],
                offset: [0, 0, 5, 5],
                color: ["#cc0000"],
                next: 11
            }),
            canvas: true
        }
    },
    {
        id: 11,
        previous: 8,
        next: 20,
        video: {
            src: 'img/videos/lesson_20/6.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 12
        }
    },
    {
        id: 12,
        previous: 11,
        next: 20,
        directions: {
            data: '<b>DIRECTIONS</b><br>Place the Black Bishop on the board to create checkmate.'
        },
        chessboard: {
            board: lesson20Assignment3({
                showIndicators: { allSides: true },
                position: '1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/8/KNR5',
                piecesArray: ['bB'],
                validatePieces: { 'bB': ['b2'] },
                pieceLimit: { bB: 2 },
                fen: '1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/1b6/KNR5',
                pieceTheme: 'simple_black_white',
                assignmentClass: 'custom-sparepiece',
                next: 14
            })
        }
    },
    {
        id: 13,
        previous: 12,
        next: 20,
        chessboard: {
            board: lesson20Assignment4({
                showIndicators: { allSides: true },
                position: '1r3rk1/3bpp1p/6p1/8/1nQ1P2P/pP2BP2/1b6/KNR5',
                assignmentClass: 'custom-sparepiece',
                from: ["square-b4", "square-a3", "square-b2"],
                to: ["square-a2", "square-b2", "square-a1"],
                offset: [0, 0, 5, 5],
                color: ["#f9e420", "#f9e420", "#cc0000"],
                next: 14
            }),
            canvas: true
        }
    },
    {
        id: 14,
        previous: 11,
        next: 20,
        directions: {
            data: '<b>DIRECTIONS</b><br>Place the Black Knight on the board to create checkmate.'
        },
        chessboard: {
            board: lesson20Assignment3({
                showIndicators: { allSides: true },
                position: '1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP2P2/3R1RK1',
                piecesArray: ['bN'],
                validatePieces: { 'bN': ['e2'] },
                pieceLimit: { bN: 1 },
                fen: '1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP1nP2/3R1RK1',
                pieceTheme: 'simple_black_white',
                assignmentClass: 'custom-sparepiece',
                next: 16
            })
        }
    },
    {
        id: 15,
        previous: 14,
        next: 20,
        chessboard: {
            board: lesson20Assignment4({
                showIndicators: { allSides: true },
                position: '1r3rk1/p3ppbp/1pQ3p1/2p1N3/P7/1P2P1Pq/1BP1nP2/3R1RK1',
                assignmentClass: 'custom-sparepiece',
                from: ["square-h3", "square-h3"],
                to: ["square-g2", "square-h1"],
                offset: [0, 0, 5, 5],
                color: ["#f9e420", "#f9e420"],
                next: 16
            }),
            canvas: true
        }
    },
    {
        id: 16,
        previous: 11,
        next: 20,
        directions: {
            data: '<b>DIRECTIONS</b><br>Place the Black pawn on the board to create checkmate.'
        },
        chessboard: {
            board: lesson20Assignment3({
                showIndicators: { allSides: true },
                position: '1b4k1/1b3p2/6p1/7n/8/8/5P2/3R1RK1',
                piecesArray: ['bP'],
                validatePieces: { 'bP': ['h2'] },
                pieceLimit: { bP: 3 },
                fen: '1b4k1/1b3p2/6p1/7n/8/8/5P1p/3R1RK1',
                pieceTheme: 'simple_black_white',
                assignmentClass: 'custom-sparepiece',
                next: 18
            })
        }
    },
    {
        id: 17,
        previous: 16,
        next: 20,
        chessboard: {
            board: lesson20Assignment4({
                showIndicators: { allSides: true },
                position: '1b4k1/1b3p2/6p1/7n/8/8/5P1p/3R1RK1',
                assignmentClass: 'custom-sparepiece',
                from: ["square-b8", "square-b7"],
                to: ["square-h2", "square-h1"],
                offset: [0, 0, 5, 5],
                color: ["#f9e420", "#f9e420"],
                next: 18
            }),
            canvas: true
        }
    },
    {
        id: 18,
        previous: 11,
        next: 20,
        directions: {
            data: '<b>DIRECTIONS</b><br>Place the White Rook on the board to create checkmate.'
        },
        chessboard: {
            board: lesson20Assignment3({
                showIndicators: { allSides: true },
                position: 'r4rk1/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',
                piecesArray: ['wR'],
                validatePieces: { 'wR': ['h8'] },
                pieceLimit: { wR: 2 },
                fen: 'r4rkR/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',
                pieceTheme: 'simple_black_white',
                assignmentClass: 'custom-sparepiece',
                next: 20
            })
        }
    },
    {
        id: 19,
        previous: 18,
        next: 20,
        chessboard: {
            board: lesson20Assignment4({
                showIndicators: { allSides: true },
                position: 'r4rkR/p3ppb1/2np4/2p5/4P3/qP2BP2/P1P5/1K1N2QR',
                assignmentClass: 'custom-sparepiece',
                from: ["square-g1", "square-h1"],
                to: ["square-g7", "square-h8"],
                offset: [0, 0, 5, 5],
                color: ["#cc0000", "#cc0000"],
                next: 20
            }),
            canvas: true
        }
    },
    {
        id: 20,
        previous: 11,
        next: 21,
        video: {
            src: 'img/videos/lesson_20/7.mp4',
            startTime: 0,
            autoStartNext: true,
            next: 21
        }
    },
    {
        id: 21,
        previous: 20,
        next: 22,
        audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
        qa: {
            id: 0,
            question: 'White is two moves from checkmate. What move can White make to block the King\'s escape?',
            answer: [
                'g2-g4',
                'Re1-e7',
                'Re1-e8+',
                'f5-f6'
            ],
            rightAnswer: 'f5-f6',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '7k/5p1p/p6p/1p3P2/qp6/2P4P/P1P2PP1/K3R3'
                }),
                hint: true
            },
        }
    },
    {
        id: 22,
        previous: 20,
        next: 23,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 1,
            question: 'White has four possible checks, which one is checkmate?',
            answer: [
                'Rc6-d6+',
                'Rc6-c5+',
                'Bd3-c4+',
                'Bd3-e4+'
            ],
            rightAnswer: 'Bd3-e4+',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'md',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/p4p2/2R5/3k4/1q1P4/3BK3/5P2/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 23,
        previous: 20,
        next: 24,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 2,
            question: 'Placing two BLACK Queens on which pair of squares makes a checkmate?',
            answer: [
                'd6 and e7',
                'b4 and d2',
                'c2 and e4',
                'h2 and h3'
            ],
            rightAnswer: 'c2 and e4',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/1k6/8/8/8/4K3/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 24,
        previous: 20,
        next: 25,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 3,
            question: 'Placing two WHITE Queens on which pair of squares makes a checkmate?',
            answer: [
                'd6 and d7',
                'b4 and c4',
                'a5 and b6',
                'b6 and d8'
            ],
            rightAnswer: 'b6 and d8',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/1k6/8/8/8/4K3/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 25,
        previous: 20,
        next: 26,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 4,
            question: 'To checkmate White in just two moves which move should Black play first?',
            answer: [
                'Kd3-e3',
                'Rb7-e7+',
                'Rb7-b1+',
                'Rb7-f7'
            ],
            rightAnswer: 'Rb7-f7',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/1r6/8/8/8/3k4/8/4K3'
                }),
                hint: true
            },
        }
    },
    {
        id: 26,
        previous: 20,
        next: 27,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 5,
            question: 'To checkmate White in just two moves which move should Black play first?',
            answer: [
                'Re7-e3+',
                'Re7-b7+',
                'Rc6-b6+',
                'Rc6-c3+'
            ],
            rightAnswer: 'Re7-b7+',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '8/4r3/2r3k1/8/8/1K6/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 27,
        previous: 20,
        next: 28,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 6,
            question: 'If only very good moves are made by both players for the rest of this game what will the end result be?',
            answer: [
                'White will checkmate Black',
                'Black will checkmate White',
                'The game must be a tie',
                'It is impossible to tell, yet'
            ],
            rightAnswer: 'White will checkmate Black',
            validateAnswer: { rightAnswer: 0, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '6k1/8/8/8/3K4/2R5/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 28,
        previous: 20,
        next: 29,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 7,
            question: 'If only very good moves are made by both players for the rest of this game what will the end result be?',
            answer: [
                'White will checkmate Black',
                'Black will checkmate White',
                'The game must be a tie',
                'It is impossible to tell, yet'
            ],
            rightAnswer: 'The game must be a tie',
            validateAnswer: { rightAnswer: 2, userAnswer: -1 },
            styleClass: 'lg',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '6k1/8/8/4B3/8/4B3/5K2/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 29,
        previous: 20,
        next: 30,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 8,
            question: 'If only very good moves are made by both players for the rest of this game what will the end result be?',
            answer: [
                'White will checkmate Black',
                'Black will checkmate White',
                'The game must be a tie',
                'It is impossible to tell, yet'
            ],
            rightAnswer: 'Black will checkmate White',
            validateAnswer: { rightAnswer: 1, userAnswer: -1 },
            styleClass: 'xxxl',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '6k1/1q6/8/8/3K4/8/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 30,
        previous: 20,
        next: 31,
        audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
        qa: {
            id: 9,
            question: 'If only very good moves are made by both players for the rest of this game what will the end result be?',
            answer: [
                'White will checkmate Black',
                'Black will checkmate White',
                'The game must be a tie',
                'It is impossible to tell, yet'
            ],
            rightAnswer: 'It is impossible to tell, yet',
            validateAnswer: { rightAnswer: 3, userAnswer: -1 },
            styleClass: 'xxxl',
            chessboard: {
                board: createChessboard({
                    showIndicators: true,
                    position: '4K1k1/5pb1/6b1/8/2Q5/8/8/8'
                }),
                hint: true
            },
        }
    },
    {
        id: 31,
        previous: 20,
        next: 32,
        audio: { src: null, stop: true },
        qa: {
            position: 'center',
            nextLesson: 'None',
            result: true,
            styleClass: 'xl',
            timeout: 7000,
            next: 32,
            lesson20 : true,
        }
    },
    {
        id: 32,
        previous: 20,
        next: null,
        video: {
            src: 'img/videos/lesson_20/8.mp4',
            startTime: 0,
            autoStartNext: true,
            next: null
        }
    },
];

let assets = [
    '/img/background_9.png',
    '/img/background_10.png',
    '/img/box.png',
    '/img/chesspieces/assignment_10_1/bK.svg',
    '/img/chesspieces/assignment_10_1/bQ.svg',
    '/img/chesspieces/assignment_10_1/bR.svg',
    '/img/chesspieces/assignment_10_1/bB.svg',
    '/img/chesspieces/assignment_10_1/bN.svg',
    '/img/chesspieces/assignment_10_1/bP.svg'
];

let config = {
    config: lessonConfig,
    assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_20/index.js